<template>
  <v-container>
    {{ $store.commit('setMetadata',  $t("nav.Aufträge") ) }}
    <div>
      <v-row justify="center">
        <v-col cols="12" class="col-md-8">
          <v-row align="center">
            <v-col v-if="hasWrite()" cols="auto">
              <form-creation-dialog />
            </v-col>
            <v-col>
              <v-text-field
                v-model="searchText"
                solo
                dense
                hide-details
                clearable
                :label="$t('actions.search')"
                prepend-inner-icon="mdi-magnify"
                @click:clear="searchText = ''"
              ></v-text-field>
            </v-col>
            <v-col cols="auto" v-if="true">
              <MultiFilter
                @filtersApply="onFiltersApply"
                @filtersReset="onFiltersReset"
                :filter-active="filterActive"
                :search-text="searchText"
                :search-text.sync="searchText"
                :created_by_filter="created_by_filter"
                :created_range_start_filter="created_range_start_filter"
                :created_range_end_filter="created_range_end_filter"
                :template_filter="template_filter"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <loading-spinner :loading="loading"/>
      <v-row justify="center">
        <v-col cols="12" class="col-md-8">
          <div>
            <v-list>
              <v-list-item
                v-for="(form, index) in filterResults(searchText)"
                :key="form.id"
                @click="href('/forms/' + form.id)"
              >
                <v-list-item-content>
                  <v-list-item-title
                    v-text="form.name"
                  ></v-list-item-title>
                  <v-list-item-subtitle
                    v-text="renderSubtitle(form)"
                  ></v-list-item-subtitle>
                </v-list-item-content>

                <v-list-item-action v-if="hasWrite()">
                  <copy-form-dialog
                    :form="form"
                    :forms="forms"
                  />
                </v-list-item-action>
                <v-list-item-action>
                  <export :form="form"/>
                </v-list-item-action>
                <v-list-item-action v-if="hasWrite() && $userController.isGerman()">
                  <v-btn icon @click="href('/forms/' + form.id + '/info')">
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </div>
        </v-col>
      </v-row>
      <v-row justify="center">
        <v-col class="col-md-8">
          <Pagination
            :current-page.sync="currentPage"
            :items="forms"
            :search-text="searchText"/>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<script>
import FormCreationDialog from '../components/form/dialog/FormCreationDialog'
import LoadingSpinner from '../components/utils/LoadingSpinner'
import DeleteFormDialog from '../components/form/dialog/DeleteFormDialog'
import Export from '../components/export/Export'
import CopyFormDialog from '../components/form/dialog/CopyFormDialog'
import SelectConflictDialog from '../components/form/dialog/SelectConflictDialog'
import {mapGetters} from 'vuex'
import RenameDocumentDialog from '@/components/form/dialog/RenameDocumentDialog'
import {format, register} from 'timeago.js'
import de from 'timeago.js/lib/lang/de'
import en from 'timeago.js/lib/lang/en_US'
import Pagination from "@/components/utils/Pagination";
import MultiFilter from "@/components/utils/MultiFilter";
import CreateNewRevisionDialog from "../components/form/dialog/CreateNewRevision.vue";

export default {
  name: 'FormList',
  components: {
    CreateNewRevisionDialog,
    MultiFilter,
    Pagination,
    RenameDocumentDialog,
    CopyFormDialog,
    Export,
    DeleteFormDialog,
    LoadingSpinner,
    FormCreationDialog,
    SelectConflictDialog
  },
  data: function () {
    return {
      currentPage: 1,
      dialog: false,
      loading: true,
      forms: [],
      searchText: '',
      filterActive: false,
      created_by_filter: "",
      created_range_start_filter: "",
      created_range_end_filter: "",
      template_filter: "",
    }
  },
  computed: {
    ...mapGetters(['config']),
  },
  created: function () {
  },
  mounted() {
    this.$store.commit('sync');
    this.initializeFiltersFromUrl();
  },
  beforeRouteEnter: function (to, from, next) {
    next(vm => vm.fetchDocs())
  },
  methods: {
    href: function (dest) {
      this.$router.push(dest)
    },
    fillDoc: function (formId) {
      this.$router.push(
        '/forms/' + formId + '/fill'
      )
    },
    initializeFiltersFromUrl() {
      const filters = this.$route.query;

      const createdRangeStart = filters.created_range_start ? new Date(filters.created_range_start) : null;
      const createdRangeEnd = filters.created_range_end ? new Date(filters.created_range_end) : null;
      const createdBy = filters.created_by || null;

      this.created_by_filter = createdBy
      this.created_range_start_filter = filters.created_range_start
      this.created_range_end_filter = filters.created_range_end
      this.template_filter = filters.template_filter

      if (createdRangeStart || createdRangeEnd || createdBy) {
        this.filterActive = true;
        this.forms = this.formsOriginal.filter(form => {
          const formCreated = new Date(form.created);
          const matchesCreator = createdBy ? form.creator === createdBy : true;
          const matchesDateRange = (!createdRangeStart || formCreated >= createdRangeStart) &&
            (!createdRangeEnd || formCreated <= createdRangeEnd);

          return matchesCreator && matchesDateRange;
        });
      }
    },
    fetchDocs: function () {
      this.$formController.getDocumentList(this.$route.query)
        .then(res => {
          this.forms = res.data
          this.formsOriginal = res.data
          this.initializeFiltersFromUrl();
          this.loading = false
        })
        .catch(res => {
          console.error(res)
          throw res
        })
    },
    onFiltersApply: function(filters) {
      console.log(filters)
      this.filterActive = Object.keys(filters).length > 0;
      this.forms = this.formsOriginal
      this.$router.push(this.$route.path + "?" + new URLSearchParams(filters).toString());

      this.forms = this.forms.filter(form => {
        const formCreated = new Date(form.created);
        const rangeStart = filters.created_range_start ? new Date(filters.created_range_start) : null;
        const rangeEnd = filters.created_range_end ? new Date(filters.created_range_end) : null;
        const matchesCreator = filters.created_by ? form.creator === filters.created_by : true;
        const matchesTemplate = filters.template_filter ? form.template === filters.template_filter : true;
        const matchesDateRange = (!rangeStart || formCreated >= rangeStart) &&
          (!rangeEnd || formCreated <= rangeEnd);

        return matchesCreator && matchesDateRange && matchesTemplate;
      });
    },
    onFiltersReset: function() {
      this.filterActive = true
      this.created_by_filter = ""
      this.created_range_start_filter = ""
      this.created_range_end_filter = ""
      this.template_filter = ""
      this.onFiltersApply({})
    },
    renderSubtitle: function (form) {
      register('de', de)
      register('en', en)
      if (localStorage.getItem('lang') === "de")
        return "Bearbeitet " + format(form.updated, 'de') + " von " + form.editorName
      else
        return "Changed " + format(form.updated, 'en') + " by " + form.editorName
    },
    filterResults(searchText) {
      const lowerSearchText = searchText.toLowerCase();
      const searchFields = ["name", "creatorName", "editorName"];
      return this.forms.filter(form => {
        return searchFields.some(field => {
          const value = form[field];
          return typeof value === "string" && value.toLowerCase().includes(lowerSearchText)
        });
      }).slice((this.currentPage - 1) * 10, (this.currentPage - 1) * 10 + 10)
    },
    hasWrite: function () {
      return this.$store.state.auth.groups.includes("write")
    }
  }
}
</script>

<style scoped></style>
